module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/virtual-rows/virtual-rows.component.css
// module id = ./src/app/examples/virtual-rows/virtual-rows.component.css
// module chunks = main